import React, { useState, useRef, useImperativeHandle, forwardRef, useEffect } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faTrashCan, faCloudArrowDown } from "@fortawesome/free-solid-svg-icons";
import { Modal, Form, Row, Col, Dropdown, List } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { message } from 'antd';
import axios from 'axios';
import { setLoader } from '../../../Slices/loaderSlice';
import { SERVER_URL, S3ACCESSURL } from '../../../databucket';
import { addFinanceEntry, editFinanceThunk, updateFinanceAttachmentThunk, removeFinanceAttachmentThunk, GetAllRecords, resetFinanceStatus } from '../../../Slices/financeSlice';
import { handleMultipleAttachment } from './attachments';
import { useParams } from 'react-router-dom';
import { AntdButton, DatePickerField, InputField, SelectInput } from '../../../blueplanitUtils/InputField';
import dayjs from 'dayjs';
import Link from 'antd/es/typography/Link';
import { getOptionsByPath } from '../../../utilsdata';

const FinanceActions = forwardRef((props, ref) => {
  const dispatch = useDispatch();
  const {
    tableData,
    categoryoptions,
    NestedDatabucket,
    FINANCE,
    FINANCE_CATEGORYS,
    FINANCE_MODE_OF_PAYMENT,
    getAssignToUsers,
  } = props;

  const [form] = Form.useForm();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalVisible2, setIsModalVisible2] = useState(false);
  const [recordToEdit, setRecordToEdit] = useState(null);
  const fileInputRef = useRef(null);
  const loginUser = useSelector((state) => state?.loginUserInfo?.loginUserDetails);
  const details = useSelector((state) => state.employee.AllEmployees);
  const usersList = useSelector((state) => state.employee.AllEmployees);
  const assignToUsersLocal = usersList.filter((user) => user.employeestatus === 'Active');
  const [editattachments, setEditAttachments] = useState([]);
  const [currentAttachments, setCurrentAttachments] = useState([]);
  const [currentRow, setCurrentRow] = useState(null);
  const [selectedCategoryIds, setSelectedCategoryIds] = useState({});
  const { Empid } = useParams();
  const token = localStorage.getItem('token');
  const id = loginUser?.id;

  useImperativeHandle(ref, () => ({
    openEdit: (record) => {
      if (record) {
        // Edit existing record
        setRecordToEdit(record);
        form.setFieldsValue({
          entries: [{
            _id: record._id,
            date: dayjs(record.date),
            category: record.category,
            subCategory: record.subCategory,
            purchaseDetails: record.purchaseDetails,
            invoice: record.invoice,
            quantity: record.quantity,
            amount: record.amount,
            spentBy: record.spentBy ? record.spentBy.split(', ') : [],
            transactionMode: record.transactionMode,
            remarks: record.remarks,
          }]
        });
        setEditAttachments((record.attachments || []).filter(att => att.status !== false).map(a => ({ filename: a.filename, data: a.data, id: a.id })));
        const opt = categoryoptions.find(o => o.value === record.category);
        if (opt) setSelectedCategoryIds({ 0: opt.id });
      } else {
        setRecordToEdit(null);
        form.resetFields();
        setEditAttachments([]);
        setSelectedCategoryIds({});
      }
      setIsModalVisible(true);
    },
    showAttachmentsModal: (attachments, row) => {
      setCurrentAttachments(attachments);
      setCurrentRow(row);
      setIsModalVisible2(true);
    }
  }));

  const handleCategoryChange = (value, fieldIndex) => {
    const opt = categoryoptions.find(o => o.value === value);
    const id = opt ? opt.id : null;
    setSelectedCategoryIds(prev => ({ ...prev, [fieldIndex]: id }));
    const currentEntries = form.getFieldValue('entries') || [];
    currentEntries[fieldIndex] = { ...currentEntries[fieldIndex], subCategory: undefined };
    form.setFieldsValue({ entries: currentEntries });
  };

  const handleCancelInternal = () => {
    setIsModalVisible(false);
    setRecordToEdit(null);
    setEditAttachments([]);
    form.resetFields();
  };

  const handleOkInternal = async () => {
    try {
      dispatch(setLoader(true));
      const values = await form.validateFields();
      const entries = values.entries.map((entry) => ({
        _id: entry._id,
        date: dayjs(entry.date).toISOString(),
        category: entry.category,
        subCategory: entry.subCategory,
        purchaseDetails: entry.purchaseDetails,
        invoice: entry.invoice,
        quantity: entry.quantity?.toString() || null,
        amount: entry.amount?.toString() || null,
        spentBy: Array.isArray(entry.spentBy) ? entry.spentBy.join(', ') : entry.spentBy,
        transactionMode: entry.transactionMode,
        remarks: entry.remarks,
        attachemnts: editattachments
      }));

      if (recordToEdit) {
        const editedEntry = entries[0];

        const hasChanges = () => {
          const original = recordToEdit;
          const fieldsToCompare = [
            'date', 'category', 'subCategory', 'purchaseDetails', 'invoice', 'quantity', 'amount', 'spentBy', 'transactionMode', 'remarks', 'attachemnts'
          ];
          for (const field of fieldsToCompare) {
            let originalValue = original[field];
            let updatedValue = editedEntry[field];
            if (field === 'date') {
              originalValue = dayjs(original.date).toISOString();
              updatedValue = dayjs(updatedValue).toISOString();

            }
            if (field === 'quantity' || field === 'amount') {
              originalValue = originalValue?.toString() || null;
              updatedValue = updatedValue?.toString() || null;
            }
            if (field === 'spentBy') {
              if (Array.isArray(originalValue)) originalValue = originalValue.join(', ');
              updatedValue = updatedValue?.toString() || null;
            }
            if (field === 'attachemnts') {
              const originalStr = JSON.stringify(originalValue || []);
              const updatedStr = JSON.stringify(updatedValue || []);
              if (originalStr !== updatedStr) return true;
              continue;
            }
            const originalStr = originalValue?.toString()?.trim() || '';
            const updatedStr = updatedValue?.toString()?.trim() || '';
            if (originalStr !== updatedStr) return true;
          }
          return false;
        };

        if (!hasChanges()) {
          message.warning('Please make changes before submitting.');
          return;
        }
        const cleanAttachments = editattachments.map(({ id, ...rest }) => rest);

        await dispatch(editFinanceThunk({ id: recordToEdit.id, ...editedEntry, userName: `${loginUser?.firstname} ${loginUser?.lastname}`, task: 'Finance Edit', editedAt: new Date().toISOString(), attachemnts: recordToEdit ? cleanAttachments : [], })).unwrap();
        message.success('Finance record updated!');
        setEditAttachments([]);
        if (props.refreshRecords) props.refreshRecords();

      } else {
        for (const entry of entries) {
          const cleanAttachments = editattachments.map(({ id, ...rest }) => rest);
          await dispatch(addFinanceEntry({ ...entry, userName: `${loginUser?.firstname} ${loginUser?.lastname}`, editedAt: new Date().toISOString(), task: 'Finance Add', attachemnts: cleanAttachments })).unwrap();
          setEditAttachments([]);
        }
        message.success('Finance entries added successfully');
        if (props.refreshRecords) props.refreshRecords(true);
      }

      setIsModalVisible(false);
      setRecordToEdit(null);
      dispatch(resetFinanceStatus());

    } catch (err) {
      setEditAttachments([]);
      message.error(err?.message || 'Required fields are missing');
    } finally {
      dispatch(setLoader(false));
    }
  };

  const handleMultipleAttachInternal = async (event) => {
    const uploaded = await handleMultipleAttachment(event, details, dispatch, id, Empid, token);
    if (!uploaded || uploaded.length === 0) return;
    setEditAttachments(uploaded);
  };

  const handleReplaceFileInternal = async (e, index) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) return;
    const formData = new FormData();
    formData.append('files', selectedFile);
    try {
      const res = await axios.post(`${SERVER_URL}/upload`, formData);
      const uploaded = res.data.files[0];
      setEditAttachments(prev => {
        const updated = [...prev];
        const current = updated[index];
        const history = [...(current.attachmetHistory || []), { ...current, updateDate: Date.now() }];
        updated[index] = { ...current, filename: uploaded.originalName, data: uploaded.url, mimetype: uploaded.mimeType, updateDate: Date.now().toString(), attachmentHistory: history };
        return updated;
      });
    } catch (err) { }
  };

  const handleDeleteAttachInternal = (index) => {
    setEditAttachments(prev => prev.filter((_, i) => i !== index));
  };

  const handleUpdateAttachmentInternal = async (file, rowId) => {
    if (!file || !rowId) return;
    const inputElement = document.createElement('input');
    inputElement.type = 'file';
    inputElement.style.display = 'none';
    document.body.appendChild(inputElement);
    const selectedFile = await new Promise((resolve) => { inputElement.onchange = (e) => resolve(e.target.files[0]); inputElement.click(); });
    document.body.removeChild(inputElement);
    if (!selectedFile) return;
    const formData = new FormData();
    formData.append('files', selectedFile);
    try {
      dispatch(setLoader(true));
      const res = await axios.post(`${SERVER_URL}/upload`, formData);
      const savedFile = res.data.files[0];
      const valuesObject = { emailId: file?.id, replacedFile: file.filename, data: savedFile.url, filename: savedFile.originalName, mimetype: savedFile.mimeType, updateDate: Date.now().toString(), addDate: file.addDate ? file.addDate : Date.now().toString(), deleteDate: null, status: true, userName: `${loginUser?.firstname}${loginUser?.lastname}` };
      const val = await dispatch(updateFinanceAttachmentThunk({ id: rowId.id, input: valuesObject })).unwrap();
      if (!val?.status) { message.error({ content: 'Faild to repplace', duration: 2 }); return; }
      setCurrentAttachments((prev) => prev.map((att) => att.id === file.id ? { ...att, filename: savedFile.originalName, data: savedFile.url, updateDate: valuesObject.updateDate } : att));
      if (props.refreshRecords) props.refreshRecords();
      message.success('Attachment updated successfully');
    } catch (error) {
      message.error('Failed to update attachment');
    } finally { dispatch(setLoader(false)); }
  };

  const handleDeleteAttachmentInternal = async (attachmentId, rowId) => {
    if (!attachmentId || !rowId) return;
    try {
      const valuesObject = { id: rowId, userId: attachmentId?.id, input: { emailId: attachmentId?.emailId, userId: attachmentId?.userId, data: attachmentId?.data, addDate: attachmentId?.addDate, replacedFile: attachmentId?.oldfile, filename: attachmentId?.filename, mimetype: attachmentId?.mimetype, deleteDate: Date.now().toString(), status: false } };
      const val = await dispatch(removeFinanceAttachmentThunk(valuesObject)).unwrap();
      if (!val?.status) { message.error({ content: 'Faild to delete', duration: 2 }); return; }
      setCurrentAttachments((prev) => prev.filter((att) => att.id !== attachmentId.id));
      if (props.refreshRecords) props.refreshRecords();
      message.success({ content: 'deleted successfully', duration: 2 });
    } catch {
      message.error({ content: 'Faild to delet', duration: 2 });
    }
  };

  useEffect(() => {
    if (isModalVisible && !recordToEdit) setEditAttachments([]);
  }, [isModalVisible, recordToEdit]);

  const exportColumns = [
    'sno', 'date', 'category', 'subCategory', 'purchaseDetails', 'invoice', 'quantity', 'amount', 'spentBy', 'transactionMode', 'remarks', 'attachments'
  ];

  const getColumnLabel = (key) => {
    const labels = { sno: 'S.No', date: 'Date', category: 'Category', subCategory: 'Sub-category', purchaseDetails: 'Product/Purchase Details', invoice: 'Invoice Number', quantity: 'Quantity', amount: 'Amount', spentBy: 'Spent By', transactionMode: 'Mode of Transaction', remarks: 'Remarks', attachments: 'Attachments' };
    return labels[key] || key;
  };

  const convertToCSV = (data, selectedColumns) => {
    const headers = selectedColumns.map(getColumnLabel).join(',') + '\n';
    const rows = data.map(row => selectedColumns.map(col => {
      if (col === 'attachments') return `"${(row.attachments && row.attachments.length > 0) ? row.attachments.map(f => f.filename || f.data || 'Unnamed').join('; ') : 'No Attachments'}"`;
      return `"${row[col] ?? ''}"`;
    }).join(','));
    return headers + rows.join('\n');
  };

  const downloadCSV = (csv, filename) => {
    const blob = new Blob([csv], { type: 'text/csv' });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const simulatePrintDialog = (dataToExport, selectedColumns) => {
    const printableContent = document.createElement('div');
    printableContent.id = 'print-content';
    printableContent.style.fontFamily = 'Arial, sans-serif';
    const table = document.createElement('table'); table.style.width = '100%'; table.style.border = '1px solid #000'; table.style.borderCollapse = 'collapse';
    const thead = document.createElement('thead'); const headerRow = document.createElement('tr');
    selectedColumns.forEach(col => { const th = document.createElement('th'); th.innerText = getColumnLabel(col); th.style.border = '1px solid #000'; th.style.padding = '5px'; headerRow.appendChild(th); }); thead.appendChild(headerRow); table.appendChild(thead);
    const tbody = document.createElement('tbody'); dataToExport.forEach(row => { const tr = document.createElement('tr'); selectedColumns.forEach(col => { const td = document.createElement('td'); if (col === 'attachments') td.innerText = (Array.isArray(row.attachments) && row.attachments.length > 0) ? row.attachments.map(f => f.filename || f.data || 'Unnamed').join('; ') : 'No Attachments'; else td.innerText = row[col] || ''; td.style.border = '1px solid #ccc'; td.style.padding = '5px'; tr.appendChild(td); }); tbody.appendChild(tr); }); table.appendChild(tbody); printableContent.appendChild(table);
    const style = document.createElement('style'); style.innerHTML = `body * { visibility: hidden; } #print-content, #print-content * { visibility: visible; } #print-content { position: absolute; top: 0; left: 0; width: 100%; }`; document.head.appendChild(style); document.body.appendChild(printableContent); window.print(); document.body.removeChild(printableContent); document.head.removeChild(style);
  };

  const handleExport = (fileFormat) => {
    if (!tableData || tableData.length === 0) { message.info('No data available for export.'); return; }
    const dataToExport = tableData.map((row, index) => ({ ...row, sno: index + 1, date: dayjs(row.date).format('DD/MM/YYYY') }));
    if (fileFormat === 'CSV') { const csvData = convertToCSV(dataToExport, exportColumns); downloadCSV(csvData, 'Finance_Report.csv'); }
    else if (fileFormat === 'PDF') simulatePrintDialog(dataToExport, exportColumns);
  };

  return (
    <>
      <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
        <AntdButton label='Filters' type="primary" onClick={() => { if (props.onShowFilters) props.onShowFilters(); }} />
        <AntdButton label='Add Finance' type="primary" style={{ marginLeft: '5px', marginRight: '5px' }} onClick={() => {
          setRecordToEdit(null);
          form.resetFields();
          setEditAttachments([]);
          setSelectedCategoryIds({});
          setIsModalVisible(true);
        }} />

        <Dropdown menu={{ onClick: ({ key }) => handleExport(key), items: [{ key: 'CSV', label: 'CSV' }, { key: 'PDF', label: 'PDF' }] }} trigger={['click']}>
          <AntdButton type="primary" label="Export" icon={<FontAwesomeIcon icon={faCloudArrowDown} />} />
        </Dropdown>
      </div>

      <Modal title={recordToEdit ? 'Edit Finance Entry' : 'Add Finance Entry'} open={isModalVisible} onOk={handleOkInternal} onCancel={handleCancelInternal} destroyOnClose okText="Save" width={700}>
        <Form layout="vertical" form={form}>
          <Form.List name="entries" initialValue={[{}]}>
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ key, name, ...restField }) => (
                  <div key={key} style={{ borderBottom: '1px solid #eee', marginBottom: 16, paddingBottom: 8 }}>
                    <Row gutter={16}>
                      <Col span={8}><Form.Item {...restField} name={[name, 'date']} required={false} label={<span>Date<span style={{ color: 'red', marginLeft: 4 }}>*</span></span>} className="tight-error-spacing" rules={[{ required: true, message: 'Please select Date' }]}><DatePickerField format="DD/MM/YYYY" style={{ width: '100%' }} /></Form.Item></Col>
                      <Col span={8}><Form.Item {...restField} name={[name, 'category']} required={false} label={<span>Category<span style={{ color: 'red', marginLeft: 4 }}>*</span></span>} className="tight-error-spacing" rules={[{ required: true, message: ' Please select Category' }]}><SelectInput options={categoryoptions} onChange={(value) => handleCategoryChange(value, name)} /></Form.Item></Col>
                      <Col span={8}><Form.Item {...restField} name={[name, 'subCategory']} required={false} label={<span>Sub-Category<span style={{ color: 'red', marginLeft: 4 }}>*</span></span>} className="tight-error-spacing" rules={[{ required: true, message: ' Please select Sub-Category' }]}><SelectInput options={getOptionsByPath(NestedDatabucket, [FINANCE, FINANCE_CATEGORYS, selectedCategoryIds[name]])} /></Form.Item></Col>
                    </Row>
                    <Row gutter={16}>
                      <Col span={8}><Form.Item {...restField} name={[name, 'purchaseDetails']} required={false} label={<span>Purchase Details<span style={{ color: 'red', marginLeft: 4 }}>*</span></span>} rules={[{ required: true, message: 'Please select Purchase Details' }]}><InputField /></Form.Item></Col>
                      <Col span={8}><Form.Item {...restField} name={[name, 'invoice']} label="Invoice Number" ><InputField /></Form.Item></Col>
                      <Col span={8}><Form.Item {...restField} name={[name, 'quantity']} label="Quantity"><InputField type="number" min={0} /></Form.Item></Col>
                    </Row>
                    <Row gutter={16}>
                      <Col span={8}><Form.Item {...restField} name={[name, 'amount']} required={false} label={<span>Amount<span style={{ color: 'red', marginLeft: 4 }}>*</span></span>} rules={[{ required: true, message: 'Please select Amount' }]}><InputField type="number" min={0} /></Form.Item></Col>
                      <Col span={8}><Form.Item {...restField} name={[name, 'spentBy']} required={false} label={<span>Spent By<span style={{ color: 'red', marginLeft: 4 }}>*</span></span>} className="tight-error-spacing" rules={[{ required: true, message: 'Please select Spent By' }]}><SelectInput options={getAssignToUsers(assignToUsersLocal)} showSearch optionFilterProp="label" /></Form.Item></Col>
                      <Col span={8}><Form.Item {...restField} name={[name, 'transactionMode']} required={false} label={<span>Transaction Mode<span style={{ color: 'red', marginLeft: 4 }}>*</span></span>} className="tight-error-spacing" rules={[{ required: true, message: ' Please select Transaction Mode' }]}><SelectInput options={getOptionsByPath(NestedDatabucket, [FINANCE, FINANCE_MODE_OF_PAYMENT])} /></Form.Item></Col>
                    </Row>
                    <Row>
                      <Col span={24}><Form.Item {...restField} name={[name, 'remarks']} label="Remarks"><InputField placeholder="Any remarks..." /></Form.Item></Col>
                    </Row>
                    <Row>
                      <Col style={{ color: "#4A90E2", cursor: "pointer" }}>
                        <input type="file" multiple ref={fileInputRef} onChange={(e) => handleMultipleAttachInternal(e)} style={{ display: 'none' }} />
                        <Link onClick={() => fileInputRef.current && fileInputRef.current.click()}><i className="fa-regular fa-folder-open" style={{ fontSize: "20px" }} aria-label="Add Multiple Attachments" /></Link>
                      </Col>
                    </Row>
                    <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
                      {editattachments?.map((attachment, index) => (
                        <div key={index} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#f5f5f5', padding: '4px 12px', borderRadius: '4px', marginBottom: '6px', minWidth: '300px' }}>
                          <span>{attachment?.filename}</span>
                          <div style={{ display: 'flex', gap: '6px' }}>
                            <input type="file" id={`file-input-${index}`} style={{ display: 'none' }} onChange={(e) => handleReplaceFileInternal(e, index)} />
                            <AntdButton label='Edit' type="primary" size="small" onClick={() => document.getElementById(`file-input-${index}`).click()} />
                            <AntdButton label='Delete' size="small" type='primary' style={{ backgroundColor: 'red', borderColor: 'red', color: '#fff' }} onClick={() => handleDeleteAttachInternal(index)} />
                          </div>
                        </div>
                      ))}
                    </div>
                    {!recordToEdit && fields.length > 1 && (<AntdButton type="link" danger onClick={() => remove(name)} label="- Remove Entry" style={{ color: 'red' }} />)}
                  </div>
                ))}
              </>
            )}
          </Form.List>
        </Form>
      </Modal>

      <Modal title="Attachments" open={isModalVisible2} onCancel={() => setIsModalVisible2(false)} footer={null}>
        <List dataSource={currentAttachments} renderItem={(file, idx) => (
          <List.Item actions={[<FontAwesomeIcon icon={faPen} key="edit" style={{ color: '#1890ff' }} onClick={() => handleUpdateAttachmentInternal(file, currentRow)} />, <FontAwesomeIcon icon={faTrashCan} key="delete" style={{ color: 'red' }} onClick={() => handleDeleteAttachmentInternal(file, currentRow.id)} />]}>
            <a href={S3ACCESSURL + file.data} target="_blank" rel="noopener noreferrer">{file.filename || `File ${idx + 1}`}</a>
          </List.Item>
        )} />
      </Modal>
    </>
  );
});

export default FinanceActions;
